import { LocationDescriptorObject } from 'history';

interface KeyValueStore {
  set: (provider: string, clickId: string, expiresInDays: number) => void;
  get: (provider: string) => string | undefined;
}

interface AffiliationSource {
  provider: string;
  clickId: string;
}

interface Tracker {
  provider: string;
  expireInDays: number;
  shouldBeTracked: (location: LocationDescriptorObject) => boolean;
  getClickId: (location: LocationDescriptorObject) => string;
}

// List of trackers. New trackers can be added in this list.
// Tackers are ordered based on priority:
// tracker with lower index has higher prioirity
const trackers: Tracker[] = [
  {
    provider: 'google',
    expireInDays: 90,
    shouldBeTracked: (location: LocationDescriptorObject) =>
      !!location.query.gclid,
    getClickId: (location: LocationDescriptorObject) => location.query.gclid,
  },
  {
    provider: 'facebook',
    expireInDays: 90,
    shouldBeTracked: (location: LocationDescriptorObject) =>
      !!location.query.fbclid,
    getClickId: (location: LocationDescriptorObject) => location.query.fbclid,
  },
  {
    provider: 'nestpick',
    expireInDays: 30,
    shouldBeTracked: (location: LocationDescriptorObject) =>
      location.query.utm_source === 'nestpick.com' &&
      !!location.query.nestpick_transaction_id,
    getClickId: (location: LocationDescriptorObject) =>
      location.query.nestpick_transaction_id,
  },
  {
    provider: 'hometogo',
    expireInDays: 30,
    shouldBeTracked: (location: LocationDescriptorObject) =>
      location.query.utm_source === 'hometogo' && !!location.query.utm_term,
    getClickId: (location: LocationDescriptorObject) => location.query.utm_term,
  },
];

export default function newAffilationTracker(keyValueStore: KeyValueStore) {
  const getSource = (): AffiliationSource | undefined => {
    const sources = trackers
      .map(({ provider }) => {
        return {
          provider,
          clickId: keyValueStore.get(provider),
        };
      })
      .filter(source => source.clickId !== undefined);

    return sources[0] as AffiliationSource | undefined;
  };

  const trackSource = (location: LocationDescriptorObject): void => {
    trackers.forEach((tracker: Tracker) => {
      if (tracker.shouldBeTracked(location)) {
        keyValueStore.set(
          tracker.provider,
          tracker.getClickId(location),
          tracker.expireInDays,
        );
      }
    });
  };

  return {
    getSource,
    trackSource,
  };
}
